import React from "react"
import { useInView } from "react-intersection-observer"
import "./Team.css"
import img1 from "../assets/picc1.jpg"
import img2 from "../assets/picc2.jpg"
import img3 from "../assets/picc3.jpg"
import { AuroraText } from "./magicui/aurora-text"
import { useTranslation } from "react-i18next"

const Team = () => {
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.2 });

  const { t, i18n } = useTranslation()

  return (
    <section className="team-section">
      <div className="section-title-container">
        <div className="mini-title-team">{t('home.team.title_card')}</div>
        <h2 className={`section-main-subtitle`}>
          {t('home.team.main_title')}{" "}
          <AuroraText>{t('home.team.main_title_special')}</AuroraText>
        </h2>
      </div>

      <div className="team-cards-container">
        <div ref={ref1} className={`team-card block-1 block-bg-1 ${inView1 ? "visible" : ""}`}>
          <div className={`text-team ${inView1 ? "fade-in-up" : ""}`}>
            <h3>{t('home.team.cards_box.card_one.title')}</h3>
            <p>
              {t('home.team.cards_box.card_one.text')}
            </p>
          </div>
          <div className={`images-team ${inView1 ? "zoom-in" : ""}`}>
            <img src={img1} alt="img1" />
          </div>
        </div>

        <div ref={ref2} className={`team-card block-2 block-bg-2 ${inView2 ? "visible" : ""}`}>
          <div className={`text-team bigger-text ${inView2 ? "fade-in-up" : ""}`}>
            <h3>{t('home.team.cards_box.card_two.title')}</h3>
            <p>
              {t('home.team.cards_box.card_two.text')}
            </p>
          </div>
          <div className={`images-team ${inView2 ? "zoom-in" : ""}`}>
            <img src={img2} alt="img3" />
          </div>
        </div>

        <div ref={ref3} className={`team-card block-3 block-bg-3 ${inView3 ? "visible" : ""}`}>
          <div className={`text-team ${inView3 ? "fade-in-up" : ""}`}>
            <h3>{t('home.team.cards_box.card_three.title')}</h3>
            <p>
              {t('home.team.cards_box.card_three.text')}
            </p>
          </div>
          <div className={`images-team ${inView3 ? "zoom-in" : ""}`}>
            <img src={img3} alt="img5" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default Team